import styled from 'styled-components';
import { breakpoints } from '@/styles/breakpoints';

const StoriesBannerSection = styled.section`
  padding: 31px 0 81px;
  overflow: hidden;

  ${breakpoints.MD} {
    padding: ${({ theme }) => theme.spacings.x10} 0;
  }

  ${breakpoints.MDL} {
    padding: ${({ theme }) => theme.spacings.x10} 0 58px;
  }

  ${breakpoints.LG} {
    padding: 86px 0 53px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 4fr);
  row-gap: ${({ theme }) => theme.spacings.x4};
  column-gap: 18px;
  grid-template-areas:
    'title'
    'illustration'
    'subtitle'
    'description'
    'list'
    'action';
  position: relative;

  ${breakpoints.MD} {
    grid-template-columns: repeat(12, 12fr);
    row-gap: ${({ theme }) => theme.spacings.x7};
    column-gap: 36px;
    grid-template-areas:
      'title . subtitle'
      'description illustration list'
      'action . list';
  }

  ${breakpoints.MDL} {
    row-gap: ${({ theme }) => theme.spacings.x7};
    grid-template-areas:
      'title title .'
      '. . subtitle'
      'description illustration list'
      'action . list';
  }

  ${breakpoints.MDL} {
    row-gap: ${({ theme }) => theme.spacings.x7};
    grid-template-areas:
      'title . .'
      '. . subtitle'
      'description illustration list'
      'action . list';
  }

  ${breakpoints.LG} {
    row-gap: ${({ theme }) => theme.spacings.x10};
    grid-template-areas:
      'title title subtitle'
      'description illustration list'
      'action illustration list';
  }
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.colors.primary.first};
  grid-area: title;
  grid-column: span 4;
  opacity: 0;

  ${breakpoints.MD} {
    grid-column: span 10;
  }

  ${breakpoints.MDL} {
    grid-column: span 12;

    br {
      display: none;
    }
  }

  ${breakpoints.LG} {
    grid-column: span 9;

    br {
      display: none;
    }
  }

  ${breakpoints.LG} {
    grid-column-start: 1;
    grid-column-end: 11;
  }
`;

const Illustration = styled.div`
  grid-area: illustration;
  grid-column-start: 2;
  grid-column-end: 5;
  margin-top: -155px;
  opacity: 0;

  svg {
    display: block;
    margin-left: auto;
  }

  ${breakpoints.MD} {
    grid-column-start: 4;
    grid-column-end: 9;
    margin-top: 0;
    position: relative;
    top: -102px;

    svg {
      margin-left: 0;
      width: 260px;
      height: 260px;
    }
  }

  ${breakpoints.MDL} {
    top: -146px;

    svg {
      width: 350px;
      height: 350px;
    }
  }

  ${breakpoints.LG} {
    grid-column-start: 5;
    grid-column-end: 9;
    top: -152px;

    svg {
      width: 417px;
      height: 418px;
    }
  }
`;

const Subtitle = styled.p`
  grid-area: subtitle;
  grid-column: span 2;
  margin-top: -68px;
  opacity: 0;

  ${breakpoints.MD} {
    position: absolute;
    right: -10px;
    top: 2px;
    margin-top: 0;
    width: 32%;
  }

  ${breakpoints.MDL} {
    position: relative;
    right: 0;
    top: 0;
    width: unset;
    grid-column-start: 9;
    grid-column-end: 13;
    margin-top: -100px;
  }

  ${breakpoints.LG} {
    position: relative;
    right: 0;
    top: 0;
    width: unset;
    grid-column-start: 10;
    grid-column-end: 12;
    place-self: end;
    padding-bottom: 30px;
  }
`;

const Description = styled.div`
  grid-area: description;
  grid-column-start: 2;
  grid-column-end: 5;
  margin-top: 45px;
  opacity: 0;

  ${breakpoints.MD} {
    grid-column-start: 1;
    grid-column-end: 4;
    margin-top: 0;
    padding-right: 3%;
  }

  ${breakpoints.MDL} {
    font-size: 24px;
    line-height: 32px;
    padding-right: 0;
    margin-top: -30px;
  }

  ${breakpoints.LG} {
    font-size: 24px;
    line-height: 32px;
    padding-right: 0;
  }
`;

const BannerList = styled.div`
  grid-area: list;
  grid-column-start: 2;
  grid-column-end: 5;

  ul {
    opacity: 0;
  }

  ${breakpoints.MD} {
    grid-column-start: 9;
    grid-column-end: 13;
    position: relative;
    left: 6px;
  }

  ${breakpoints.MDL} {
    left: 0;
    padding-top: 92px;
  }

  ${breakpoints.LG} {
    left: 0;
    grid-column-start: 10;
    padding-top: 83px;
  }
`;

const Action = styled.div`
  grid-area: action;
  grid-column-start: 2;
  grid-column-end: 5;
  padding-top: 9px;

  a,
  button {
    opacity: 0;
  }

  ${breakpoints.MD} {
    grid-column-start: 2;
    grid-column-end: 5;
    padding-top: 0;
    margin-top: -45px;
  }

  ${breakpoints.MDL} {
    margin-top: -140px;
  }

  ${breakpoints.LG} {
    margin-top: -30px;
  }
`;

export {
  StoriesBannerSection,
  Grid,
  Title,
  Illustration,
  Subtitle,
  Description,
  BannerList,
  Action,
};
